<template>
    <div>
        <h1>Loading your account...</h1>
    </div>
</template>
<script>
import cookie from "cookie.js"
export default {
     created: async function () {
    console.log("create call")
    let email = this.$route.query.email
    let apiKey = this.$route.query.key
    if (this.$route.query.inApp){
    this.$store.commit("setInApp", true)
    this.$store.commit("setHideNavBar", true)
    }
    cookie.set("broadcaster-email",email, { path: '/' })
    cookie.set("broadcaster-key",apiKey, { path: '/' })
    this.$store.commit('setAuth', { email: email, key: apiKey })

    this.$store.commit("setBroadcasterChannels", [{
        "key": apiKey,
        "email": email
    }])
    if (this.$route.query.page){
   this.$router.push('/broadcaster/'+this.$route.query.page);
    }else{
    this.$router.push('/broadcaster/seasonpass');
    }
   }
}

</script>